import { render, staticRenderFns } from "./AssociateQuery.vue?vue&type=template&id=8da48ee0&scoped=true&"
import script from "./AssociateQuery.vue?vue&type=script&lang=js&"
export * from "./AssociateQuery.vue?vue&type=script&lang=js&"
import style0 from "./AssociateQuery.vue?vue&type=style&index=0&id=8da48ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da48ee0",
  null
  
)

export default component.exports